module.exports = __webpack_public_path__ + "static/media/deathpool.c9bc2129.jpg";